<template>
  <v-row>
    <v-col cols="12">
      <PersonsTabAll />
    </v-col>
  </v-row>
</template>

<script>
import PersonsTabAll from '@/components/persons/PersonsTabAll'

export default {
  components: {
    PersonsTabAll
  }
}
</script>

<style scoped></style>
